<div
  class="flex min-h-[3.5rem] flex-wrap items-center justify-between gap-2 border-b px-3"
>
  <ag1-title [label]="label()" [state]="state()" />

  @if (showTabs()) {
    <p-divider layout="vertical" />

    <!-- tabs -->
    <p-tabs [value]="activeTab()" class="grow">
      <p-tablist>
        @for (tab of tabs(); track tab.route) {
          <p-tab [value]="tab.route" [routerLink]="tab.route">
            <span>{{ tab.label }}</span>
          </p-tab>
        }
      </p-tablist>
    </p-tabs>
  }

  <!-- actions -->
  @if (actionsTemplateRef()) {
    <div class="ml-auto flex items-center gap-3">
      <ng-container *ngTemplateOutlet="actionsTemplateRef()" />
    </div>
  }
</div>
